<template>
  <section class="version-tip-wrapper" v-if="isShow">
    <img class="huojian" src="./images/huojian.svg" />
    <div class="vtheader">
      <span class="title">{{ title }}</span>
      <span class="date">更新日期：{{ updateTime }}</span>
    </div>
    <div class="vtbody">
      <!-- <span class="title" v-if="title">【{{ title }}】</span> -->
      <span class="content" v-html="Utils.presetHtmlText(newFunction)" />
    </div>
    <div class="vtfooter" @click="updateVersion">我知道了</div>
  </section>
</template>

<script setup>
  import { onMounted, ref } from 'vue';
  import * as Request from '@/assets/request';
  import * as Utils from '@/assets/utils';

  const isShow = ref(false);

  const newFunction = ref('');
  const title = ref('');
  const version = ref('');
  const updateTime = ref('');
  const getText = async () => {
    const result = await Request.post({
      url: '/22001/facade/notice/release/announcement'
    });
    if(result?.code != 200) return;

    title.value = result.data?.title || '名称';
    version.value = result.data?.version || '';
    updateTime.value = result.data?.updateTime || '';
    newFunction.value = result.data?.newFunction.join('\n');

    window.localStorage.getItem('app_version') != version.value && (isShow.value = true);
  }
  onMounted(() => {
    getText();
  })

  const updateVersion = () => {
    window.localStorage.setItem('app_version', version.value);
    isShow.value = false;
  }
</script>

<style scoped lang="less">
@import "./index.less";
</style>
